<ng-container *ngIf="!hideLayout">
  <sm-header (onToggle)="sideNav.toggle()"></sm-header>
</ng-container>

<mat-sidenav-container>
  <mat-sidenav
    *ngIf="!hideLayout"
    role="navigation"
    autoFocus="false"
    [opened]="sideNavState"
    fixedInViewport
    [fixedTopGap]="bodyOffset"
    [mode]="sidenavMode"
  >
    <sm-sidebar></sm-sidebar>
  </mat-sidenav>
  <mat-sidenav-content role="main" [ngStyle]="{'margin-top': !hideLayout ?  '64px' : '0px'}">
    <div class="body-offset" [ngClass]="{ 'p-4': !hideLayout }">
      <router-outlet></router-outlet>
      <sm-message-panel *ngIf="!hideMessagePanel"></sm-message-panel>
      <!-- <mat-progress-spinner></mat-progress-spinner> not--> 
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<sm-loader></sm-loader>
<sm-auto-login-loader></sm-auto-login-loader>
